import { useSimpleRegistrationContext } from "pages/SimpleRegistrationsPage";
import { Box as MuiBox, Button as MuiButton, styled } from "@mui/material";
import { SlideModal } from "components/Modal/SlideModal";
import { Container } from "components/SimpleRegistrations/Container";
import { Header } from "components/SimpleRegistrations/Header";
import { Body } from "components/SimpleRegistrations/Body";
import { Footer } from "components/SimpleRegistrations/Footer";
import { CustomerList } from "components/SimpleRegistrations/landscape/CustomerList";
import { CustomersList } from "components/SimpleRegistrations/landscape/CustomersList";
import { CustomerType } from "~/type/customer";

interface SimpleRegistrationsCustomerListModalProps {
  open: boolean;
  onClose: (route?: string, customer?: CustomerType) => void;
}

const Box = styled(MuiBox)`
  &.container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &.title {
    font-size: 3vw;
    font-weight: bold;
  }

  &.title-landscape {
    margin-bottom: 1vw;
  }

  &.title-portrait {
    margin-bottom: 3vw;
  }

  &.disclaimer {
    font-size: 3vw;
    color: #bbbbbb;
  }

  &.disclaimer-landscape {
    font-size: 2vw;
  }

  &.disclaimer-portrait {
    font-size: 3vw;
  }
`;

const Button = styled(MuiButton)`
  &.new-customer-button {
    width: 100%;
    height: 10vh;
    font-size: 3vw;
    color: black;
    text-decoration: underline;
    text-underline-offset: 6px;
  }
`;

export function SimpleRegistrationsCustomerListModal({
  open,
  onClose,
}: SimpleRegistrationsCustomerListModalProps) {
  const { isLandscape, customers, setLoading } = useSimpleRegistrationContext();

  const layoutMode = isLandscape ? "landscape" : "portrait";

  return (
    <SlideModal open={open} disableSlide={true}>
      <Container>
        <Header onClose={onClose} />
        <Body>
          <Box className="container">
            <div>
              <Box className={`title title-${layoutMode}`}>
                다음과 같은 고객 정보가 조회되었습니다.
              </Box>
              {customers.length === 1 ? (
                <CustomerList customer={customers[0]} />
              ) : (
                <CustomersList
                  customers={customers}
                  onClick={(customer) => {
                    onClose("registration", customer);
                  }}
                />
              )}
              <Box className={`disclaimer disclaimer-${layoutMode}`}>
                ∙ 본인이 아닌 정보로 접수한 경우 법적 책임은 접수한 당사자에게
                있습니다.
              </Box>
            </div>
            <Box>
              <Button
                className="new-customer-button"
                onClick={() => {
                  setLoading(false);
                  onClose("registration_new");
                }}
              >
                새로운 고객으로 접수하겠습니다.
              </Button>
            </Box>
          </Box>
        </Body>
        {customers.length === 1 && (
          <Footer
            text="다음"
            onClick={() => onClose("registration", customers[0])}
          />
        )}
      </Container>
    </SlideModal>
  );
}
